import { Box, Typography, useTheme } from "@mui/material";
import React, { useRef, useState } from "react";
import documentcoverimage from "../../../../../../../media/images/documentcoverimage1.png";
import PasswordEyes from "../../../../../../../media/images/icons/password_eyes";
import CustomButton from "../../../../../../components/CustomButton";
import PreviewImageModal from "../PreviewImageModal";
import Viewer from "react-viewer";

interface Props {
  handleUploadFile: (file: File, title: string) => void;
  title: string;
  name?: string;
  urlAttach?: string;
}

export default function DocumentCard(props: Props) {
  const { handleUploadFile, title, name, urlAttach } = props;
  const theme = useTheme();
  const myRef = useRef<HTMLInputElement>(null);
  const [filePath, setFilePath] = useState<string | undefined>(undefined);
  const [previewModal, setPreviewModal] = useState(false);
  const [visible1, setVisible1] = React.useState(false);

  return (
    <Box
      sx={{
        display: "flex",
        position: "relative",
        flexDirection: "column",
        gap: "8px",
      }}
    >
      <Viewer
        visible={visible1}
        drag
        noToolbar
        onClose={() => {
          setVisible1(false);
        }}
        images={[{ src: filePath || urlAttach || "", alt: "" }]}
      />
      <PreviewImageModal
        image={filePath}
        open={previewModal}
        setOpen={setPreviewModal}
      />
      <Typography
        sx={{
          textAlign: "center",
          fontWeight: "700",
          color: theme.palette.primary[600],
        }}
      >
        {name}
      </Typography>
      <style>
        {`
        .ant-image-preview-footer{
        bottom:80px;
        }
        .ant-image-preview-operations {
        background-color:${theme.palette.secondary.main}
        }
        // .ant-image-preview-body{
        // left:8px !IMPORTANT;
        // right:8px !IMPORTANT;
        // }
        `}
      </style>
      <img
        style={{
          width: "100%",
          height: "200px",
          objectFit: "cover",
          borderRadius: "10px",
        }}
        src={filePath || urlAttach || documentcoverimage}
        alt=""
      />
      {/* )} */}
      <input
        ref={myRef}
        hidden
        type="file"
        onChange={(e) => {
          if (e.target.files?.length) {
            const myFile = e.target.files[0];

            // handleUploadFile(e.target.files[0], index);

            handleUploadFile(e.target.files[0], title);

            setFilePath(URL.createObjectURL(myFile));
          }
        }}
      />
      <Box
        sx={{
          width: "100%",
          paddingX: "8px",
          position: "absolute",
          display: "flex",
          bottom: "8px",
          gap: "8px",
        }}
      >
        <CustomButton
          justifyContent="center"
          onClick={() => {
            if (filePath?.length || urlAttach) setVisible1(true);
          }}
          // onClick={() => setVisible(true)}

          bgColor={theme.palette.primary.main}
          title={"مشاهده"}
          fSize="14px"
          fWeight="700"
          borderColor={theme.palette.primary.main}
          py="8px"
          px="10px"
          gap="4px"
          borderRadius="6px"
          textColor={"#fff"}
          icon2={<PasswordEyes color="#fff" size={22} />}
        />
        <CustomButton
          flex={1}
          justifyContent="center"
          onClick={() => myRef.current?.click()}
          bgColor={theme.palette.secondary.main}
          title={"بارگزاری/ویرایش"}
          fSize="14px"
          fWeight="700"
          py="10px"
          px="6px"
          gap="4px"
          borderRadius="6px"
          textColor={"#fff"}
          icon1={<PasswordEyes color="#fff" size={22} />}
        />
      </Box>
    </Box>
  );
}
